class FriendlyFractionNodeView { 

	constructor(node, view, getPos) {
		this.dom = this.contentDOM  = document.createElement("span")
		this.contentDOM.className="friendlyFraction"
	}

}

export default FriendlyFractionNodeView